var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 5.46734C10.375 5.46734 10.4313 5.47359 10.4875 5.47359L2.43125 2.07984C2.01875 1.91109 1.5625 2.21109 1.5625 2.66109V4.97984C1.5625 5.26734 1.75625 5.51734 2.0375 5.58609L6.5625 6.71734L2.0375 7.84859C1.75625 7.91734 1.5625 8.16734 1.5625 8.45484V10.7736C1.5625 11.2236 2.01875 11.5236 2.43125 11.3486L5.9375 9.87359C5.9375 9.86109 5.9375 9.85484 5.9375 9.84234C5.9375 7.42984 7.9 5.46734 10.3125 5.46734Z",
    fill: "#0081C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 6.71734C8.5875 6.71734 7.1875 8.11734 7.1875 9.84234C7.1875 11.5673 8.5875 12.9673 10.3125 12.9673C12.0375 12.9673 13.4375 11.5673 13.4375 9.84234C13.4375 8.11734 12.0375 6.71734 10.3125 6.71734ZM11.1188 11.0923L10.0875 10.0611C10.0312 10.0048 9.99375 9.92359 9.99375 9.84234V8.27984C9.99375 8.10484 10.1312 7.96734 10.3062 7.96734C10.4812 7.96734 10.6187 8.10484 10.6187 8.27984V9.71109L11.5562 10.6486C11.6812 10.7736 11.6812 10.9673 11.5562 11.0923C11.4375 11.2173 11.2438 11.2173 11.1188 11.0923Z",
    fill: "#0081C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleSend);
export default __webpack_public_path__ + "static/media/schedule_send.c47330b7a80acbefac61812d44d47d02.svg";
export { ForwardRef as ReactComponent };